<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
          v-for="radio in formRadios"
          :key="radio.name"
        >
          <input
            class=""
            :id="radio.name"
            type="checkbox"
            :name="radio.name"
            :value="radio.value"
            v-model.trim="form.answer_q3"
            @input="invokeTouch($v.form.answer_q3)"
          />
          <label :for="radio.name" class="form__label">{{ radio.label }}</label>
        </div>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question3',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Która droga komunikacji była dla Pana/Pani najwygodniejsza?',
    number: 3,
    form: {
      answer_q3: [],
    },
    formRadios: [
      {
        name: 'e-mail',
        value: 'wiadomości e-mail',
        label: 'wiadomości e-mail',
      },
      {
        name: 'phone',
        value: 'telefon',
        label: 'telefon',
      },
      {
        name: 'videochat',
        value: 'rozmowa internetowa i wideokonferencja',
        label: 'rozmowa internetowa i wideokonferencja',
      },
      {
        name: 'asana',
        value: 'Asana',
        label: 'Asana',
      },
      {
        name: 'slack',
        value: 'Slack',
        label: 'Slack',
      },
    ],
  }),
  validations() {
    return {
      form: {
        answer_q3: {
          required,
        },
      },
    };
  },
};
</script>
